import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 50 50" {...props}>
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h50v50H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <g transform="translate(1 -1)">
          <rect
            data-name="Rectangle 734"
            width={48}
            height={47.5}
            rx={2}
            transform="translate(0 2)"
            fill={props.fillPrimary}
          />
          <text
            transform="translate(24 42)"
            fill={props.fillSecondary}
            fontSize={45}
            fontFamily="Rubik-Bold, Rubik"
            fontWeight={700}
          >
            <tspan x={-18.63} y={0}>
              {'M'}
            </tspan>
          </text>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
